import './header.scss';

import enquire from 'enquire.js';
import { Responsive } from '../utils';

/**
 * version    1.0
 * class      <type> (Header)
 * classdesc  Component that manage the page header
 */
export class Header {
  constructor() {
    const widget = this;

    widget.vars = {
      isDesktop: true,
      menuStack: [], // Elenco sezioni aperte del menù. Su desktop indica solo il primo livello (visibile su hover)
    };

    widget._initUIElements();
    widget._initResponsive();
    widget._initFixedOnScroll();
    widget._initMobileMenu();
    widget._initDesktopMenu();
    widget._initLanguageSelector();
    widget._initCookieLanding();

    // trigger event for GA (menù,logo) FRGR20-1053
    $(document).trigger('headerloaded');
  }

  // private methods

  _initUIElements() {
    const widget = this;
    widget.vars._$html = $('html');
    widget.vars._$mainHeader = $('.header');
    widget.vars._$mainMenu = $('.main-menu');
    widget.vars._$menuActions = $('.main-menu__actions');
  }

  _checkIfDesktop() {
    // Si suppone "desktop" solo da 1025px di larghezza del viewport in su; altrimenti è "mobile".
    // È l'unica distinzione presa in esame.
    const breakpoint = Responsive.getCurrentBreakpointName();
    return breakpoint === 'md' || breakpoint === 'lg';
  }

  _initResponsive() {
    const widget = this;

    function handleResolutionChange() {
      // Si chiude il menù in caso di cambio risoluzione
      widget.closeMenu();
      widget.vars.isDesktop = widget._checkIfDesktop();
    }

    enquire.register(`${Responsive.getBreakpointMaxMediaQuery('sm')}`, handleResolutionChange);
    enquire.register(`${Responsive.getBreakpointMinMediaQuery('md')}`, handleResolutionChange);

    handleResolutionChange();
  }

  // Apre il menù al percorso indicato
  _setCurrentBranch(stack, backButton) {
    const widget = this;
    widget.vars.menuStack = stack;
    const opening = widget.vars.menuStack.length > 0;

    $('.main-menu__tree').find('a').each(function () {
      const $link = $(this);
      const $parentLi = $link.closest('li');
      const hasSubmenu = $parentLi.find('ul').length > 0;
      if (hasSubmenu) {
        $link.attr('aria-expanded', false);
      } else {
        $link.removeAttr('aria-expanded');
      }
    });

    $('.main-menu__tree-link--last-open').removeClass('main-menu__tree-link--last-open');
    // il menù non deve MAI chiudersi perche' ho cliccato sul backButton
    if (!backButton) {
      widget.vars._$html.toggleClass('header-open-menu', opening);
      widget.vars._$mainHeader.toggleClass('header--open-menu', opening);
    }
    if (!opening) {
      widget.vars._$mainMenu.removeAttr('data-current-branch');
    } else {
      widget.vars._$mainMenu.find('.main-menu__tree').scrollTop(0);
      widget.vars._$mainMenu.attr('data-current-branch', widget.vars.menuStack.join('_'));
      widget.vars.menuStack.forEach((_, index) => {
        const id = `#btn_${widget.vars.menuStack.slice(0, index + 1).join('_')}`;
        $(id).attr('aria-expanded', true);
      });
      $(`#btn_${widget.vars.menuStack.join('_')}`).addClass('main-menu__tree-link--last-open');
    }
  }

  _initFixedOnScroll() {
    const widget = this;
    // Posizionamento fixed dell'header principale in caso di scroll verticale
    if (widget.vars._$mainHeader.length > 0) {
      document.addEventListener('scroll', () => {
        const { top } = widget.vars._$mainHeader[0].getBoundingClientRect();
        widget.vars._$mainHeader.toggleClass('header--fixed', top < 0);
      }, {
        passive: true,
      });
    }
  }

  // Apre il menù corrispondente al pulsante premuto
  // Si suppone che i pulsanti abbiano un'id della forma 'btn_percorso', dove "percorso" è un
  // elenco separato da underscore che rappresenta il percorso del menù da aprire (lo "stack").
  // Ad esempio 'btn_women_newFeatured', cui corrisponde lo stack ['women', 'newFeatured'].
  // I pulsanti *devono* avere l'attributo aria-controls impostato, ed esso dev'essere nel
  // formato 'menu_percorso', dove "percorso" è come indicato sopra (quindi nell'esempio sarà
  // 'menu_women_newFeatured').
  _openRelMenuStack(button) {
    const widget = this;
    const menuSection = $(button).attr('aria-controls');
    if (menuSection !== undefined) {
      widget._setCurrentBranch(menuSection.split('_').slice(1), false);
    }
  }

  // GESTIONE MENU` VERSIONE MOBILE
  _initMobileMenu() {
    const widget = this;

    if (!widget._checkIfDesktop()) {
      widget.vars._$html.find('#mainMenuTop').attr('role', 'dialog');
      widget.vars._$html.find('#mainMenuTop').attr('aria-modal', 'true');
    }

    // Apertura, chiusura e back menù (visibili solo in mobile)
    $('#openMainMenu').on('click', () => {
      widget.vars._$html.addClass('header-open-menu');
      widget.vars._$mainHeader.addClass('header--open-menu');
    });

    $('#closeMainMenu').on('click', () => {
      widget.closeMenu();
    });

    $('#goBackMenu').on('click', () => {
      widget._setCurrentBranch(widget.vars.menuStack.slice(0, widget.vars.menuStack.length - 1), true);
      widget._closeLanguageSelector();
    });

    $(document).on('click', '.main-menu__tree-link[aria-controls]', function (e) {
      if (!widget.vars.isDesktop) {
        e.preventDefault();
        widget._openRelMenuStack(this);
      }
    });

    $('.main-menu__item-image-wrapper').each(function () {
      const $figure = $(this);
      const treeListId = $figure.closest('.main-menu__tree-list').attr('id');
      const imageDefault = $figure.attr('data-image-default');
      const imageMobile = $figure.attr('data-image-mobile');
      let styles = '';
      const selector = `#${treeListId} .main-menu__item-image-wrapper`;

      if (typeof imageDefault !== typeof undefined && imageDefault !== false && imageDefault !== '') {
        styles += `${selector} { background-image: url("${imageDefault}"); }`;
      }
      if (typeof imageMobile !== typeof undefined && imageMobile !== false && imageMobile !== '') {
        styles += `@media screen and (max-width: 1024px) { ${selector} { background-image: url("${imageMobile}"); } }`;
      }
      if (styles !== '') {
        $('head').append(`<style> ${styles} </style>`);
      }
    });

    if (!widget.vars.isDesktop) {
      widget._initMobileModalControls($('#mainMenuTop'));
    }
  }

  _initMobileModalControls($elem) {
    // temporary trap per accessibilità (evita di atterrare ad elementi sotto l'overlay con il tab)
    const $focusableElements = $elem.find('button, a');

    $elem.on('keydown', (e) => {
      const $lastElement = $focusableElements.last();
      if (e.key === 'Tab') {
        if (!e.shiftKey && $(document.activeElement).is($lastElement)) {
          e.preventDefault();
          $('#closeMainMenu').trigger('focus');
        }
      }
    });
  }

  // GESTIONE MENU` VERSIONE DESKTOP
  _initDesktopMenu() {
    const widget = this;

    // Controlla se un elemento si trova all'interno del menù
    function isInsideMenu(element) {
      const $element = $(element);
      return $element.hasClass('main-menu__tree-first-level') || $element.hasClass('main-menu__tree-list--ul');
    }

    $(document).on('mouseenter', '.main-menu__tree-first-level > .main-menu__tree-link', function () {
      if (widget.vars.isDesktop) {
        widget._openRelMenuStack($(this));
      }
    });

    $(document).on('mouseenter', '.main-menu__tree-first-level > .main-menu__tree-link', function () {
      if (widget.vars.isDesktop) {
        if ($('#filterBy').length > 0) {
          $('#filterBy').toggleClass('hidden', true);
        }
        if ($('div#searchR19').length > 0 && $('div#searchR19').is(':visible')) {
          $('.timeline-r19-modal.in').css('display', 'block');
          $('#searchR19').find('input').val('').trigger('input');
          $('#searchR19').addClass('hidden');
          $('body').removeClass('header-open-search-r19');
        }
        widget._openRelMenuStack($(this));
      }
    });

    $(document).on('mouseleave', '.main-menu__tree-first-level', (event) => {
      if (widget.vars.isDesktop && !isInsideMenu(event.relatedTarget)) {
        widget.closeMenu();
      }
    });
  }

  _initLanguageSelector() {
    const widget = this;

    $('.main-menu__language .main-menu__action').on('click', (e) => {
      e.preventDefault();
      widget._openLanguageSelector();
    });

    // copio la label della lingua corrente come valore da mostrare nel menu header
    if ($('.language-selector__list__item--selected').length > 0) {
      $('#currentLanguage').text($('.language-selector__list__item--selected').text());
    }
  }

  _openLanguageSelector() {
    const widget = this;
    const $languageSelector = $('.language-selector');
    if (widget.vars.isDesktop) {
      $('#modalHeaderLanguageSelector .modal-body').append($languageSelector);
      $('#modalHeaderLanguageSelector').modal('show');
    } else {
      $('#mainMenuTop').after($languageSelector);
      $('.main-menu').addClass('main-menu--selector-open');
      $('#mainMenuTop').find('.main-menu__tree-first-level a').attr('tabindex', '-1');
      $('.language-selector__list__item a').first().trigger('focus');
      widget._initMobileModalControls($languageSelector);
    }
  }

  _closeLanguageSelector() {
    $('.main-menu').removeClass('main-menu--selector-open');
    $('#mainMenuTop').find('.main-menu__tree-first-level a').attr('tabindex', '0');
  }

  _initCookieLanding() {
    const $cookieOverlay = $('.cookie__container');
    if ($cookieOverlay.length > 0) {
      $cookieOverlay.find('.modal-title').trigger('focus');
    }
  }

  // PUBLIC METHODS

  closeMenu() {
    this._setCurrentBranch([], false);
  }
}
